<template>
  <div class="order-div">
    <Form :rules="ruleFrom" :label-width="120" class="order-details" disabled>
      <Divider orientation="left">{{ $t("orderInfo") }}</Divider>
      <div class="from-div">
        <Row>
          <Col span="6">
            <FormItem :label="$t('order_userRef')" prop="shipperRef">
              <Input v-model="orderDetails.client_refer_code"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('order_number')" prop="shipperRef">
              <Input v-model="orderDetails.airway_number"></Input>
            </FormItem>
          </Col>
          <!-- <Col span="6">
            <FormItem :label="$t('orderservice')" prop="shipperRef">
              <Input disabled v-model="orderDetails.cod_type"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('order_price')" prop="shipperRef">
              <Input disabled v-model="orderDetails.cod_amount"></Input>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem :label="$t('packageType')" prop="shipperRef">
              <Input disabled v-model="orderDetails.product"></Input>
            </FormItem>
          </Col> -->
          <Col span="6">
            <FormItem :label="$t('totalNoofpieces')" prop="shipperRef">
              <Input v-model="orderDetails.quantity"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('claim_weight')" prop="shipperRef">
              <Input :value="orderDetails.claim_weight"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('battery')" prop="shipperRef">
              <Input :value="orderDetails.battery == 0 ? '否' : '是'"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('is_solely')" prop="shipperRef">
              <Input
                :value="orderDetails.is_solely == 'YES' ? '是' : '否'"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem FormItem :label="$tz('体积,预报')">
              <Input :value="orderDetails.claim_volume"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem FormItem :label="$t('codAmount')">
              <Input :value="orderDetails.cod_amount"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem FormItem label="是否买保险">
              <Input :value="orderDetails.insurance_status"></Input>
            </FormItem>
          </Col>
          <Col span="18">
            <FormItem :label="$t('order_desc')" prop="shipperRef">
              <Input
                type="textarea"
                v-model="orderDetails.remarks"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Divider orientation="left">{{ $t("shippingInfo") }}</Divider>
      <div class="from-div">
        <Row :gutter="10">
          <Col span="8">
            <FormItem :label="$t('company')" prop="shipperRef">
              <Input v-model="orderDetails.consignee"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$tz('平台')" prop="shipperRef">
              <Input v-model="orderDetails.platform"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('from_country')" prop="shipperRef">
              <Input v-model="orderDetails.from_country_title"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('target_country')" prop="shipperRef">
              <Input v-model="orderDetails.to_country_title"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('city_name')" prop="shipperRef">
              <Input v-model="orderDetails.city_name" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('warehouseName')" prop="shipperRef">
              <Input v-model="orderDetails.warehouse"></Input>
            </FormItem>
          </Col>
          <!-- <Col span="8">
            <FormItem :label="$t('channel_code')" prop="shipperRef">
              <Input v-model="orderDetails.transport_mode" disabled></Input>
            </FormItem>
          </Col> -->
          <Col span="8">
            <FormItem :label="$t('method_name')" prop="shipperRef">
              <Input v-model="orderDetails.transport_code"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('contact')">
              <Input v-model="orderDetails.consignee_contact"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_phone')" prop="shipperRef">
              <Input v-model="orderDetails.consignee_cellular"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('Area')" prop="consigneeInfo.area">
              <Input
                type="textarea"
                :disabled="!modification"
                v-model="orderDetails.area"
                :rows="1"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem :label="$t('order_address')" prop="shipperRef">
              <Input
                type="textarea"
                v-model="orderDetails.consignee_address"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Divider orientation="left">{{ $t("doubleInfo") }}</Divider>
      <div class="from-div">
        <Table border :columns="tableTitle" :data="orderDetails.goods"></Table>
      </div>
      <Divider v-if="orderDetails.platform === '速卖通'" orientation="left">{{
        $t("平台货物详情")
      }}</Divider>
      <div class="from-div" v-if="orderDetails.platform === '速卖通'">
        <Table
          border
          :columns="tableTitle1"
          :data="orderDetails.platforms"
        ></Table>
      </div>
    </Form>
  </div>
</template>

<script>
import { getDoubleDetails } from "@/api/double/list";
export default {
  props: {
    awbno: {
      type: String,
    },
  },
  data() {
    return {
      serviceList: ["NCND", "NOR"],
      packageTypeRadio: ["XPS", "DOX"],
      ruleFrom: {
        shipperRef: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur",
          },
        ],
      },
      orderDetails: {},
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("cargo_number"),
        key: "cargo_number",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("shop_name"),
        key: "shop_name",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("case_number"),
        key: "case_number",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: '数量',
        key: "packing_list_out_number",
        align: "center",
        tooltip: true,
      });
      columns.push({
        title: this.$t("warehouseName"),
        key: "store_location",
        tooltip: true,
        align: "center",
      });
      return columns;
    },
    tableTitle1() {
      let columns = [];
      columns.push({
        title: this.$tz("商品,ID"),
        key: "goods_id",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$tz("数量,(,PCS,)"),
        key: "goods_pcs",
        tooltip: true,
        align: "center",
      });
      return columns;
    },
  },
  mounted() {
    getDoubleDetails(this.awbno).then((res) => {
      this.orderDetails = res.data.payload;
    });
  },
};
</script>

<style lang="less">
.from-div {
  border: none;
  border-bottom: 1px solid #e8eaec;
  padding: 30px 10px 10px;
  margin-top: -28px;
}
.from-div:last-child {
  border: none;
}
.order-div {
  height: 700px;
  overflow: auto;
  border: 1px solid #e8eaec;
  border-radius: 6px;
}
</style>
